import { render } from "./ChooseTemplateModal.vue?vue&type=template&id=7486c963&scoped=true"
import script from "./ChooseTemplateModal.vue?vue&type=script&lang=ts"
export * from "./ChooseTemplateModal.vue?vue&type=script&lang=ts"

import "./ChooseTemplateModal.vue?vue&type=style&index=0&id=7486c963&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7486c963"

export default script